import { combineReducers } from '@reduxjs/toolkit';
import { createFetchReducer } from 'store/setLocalStore';
import { ClinicNotesDetailState, ClinicNotesListState } from '../types';
import clinicNotesListReducer, { shareClinicNotesReducer } from './clinicNotesList';
import clinicNotesDownload from './clinicNotesDownload';
import * as actions from '../actions';

export interface ClinicalNotes {
  detail: ClinicNotesDetailState;
  list: ClinicNotesListState;
}

export const DetailResetReducer = {
  [actions.RESET_DETAIL]: (state: ClinicNotesDetailState) => {
    state.data = null;
  }
};

export default combineReducers({
  detail: createFetchReducer(actions.GET_DETAIL, true, DetailResetReducer),
  authLiteDocument: createFetchReducer(actions.GET_AUTH_LITE_DOCUMENT_BY_ID),
  download: clinicNotesDownload,
  list: clinicNotesListReducer,
  shareClinicNotes: shareClinicNotesReducer
});
